import CompareMaterialsStore from "../stores/CompareMaterialsStore";
import { useGlobalState } from "./useGlobalState";

const useCompareMaterialsStore = (): CompareMaterialsStore => {
  const [compareMaterialsStore] = useGlobalState("compareMaterialsStore");

  return compareMaterialsStore;
};

export default useCompareMaterialsStore;